import { Heading,Box } from "@chakra-ui/react";
import Inputdata from "./inputdata";

import Topbooked from './Top booked Medical tests'


export default  function Home(){






    return <>
   
    <Topbooked />
    
    
    </>
}